import errorImage from "shared/assets/error.svg"
import emptyImage from "shared/assets/empty.svg"

const array = {
  error: { src: errorImage, alt: "Ошибка загрузки данных" },
  empty: { src: emptyImage, alt: "Ничего не найдено" },
}

export function getImageProps(type: "error" | "empty"): Record<"alt" | "src", string> {
  return array[type]
}
